/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignAclDestroyPathParams, CampaignAclDestroyResponse } from '../types/CampaignAclDestroy'

/**
 * DELETE /campaigns/:campaign/access/:user
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::destroy
 */
export async function campaignAclDestroy(
	campaign: CampaignAclDestroyPathParams['campaign'],
	user: CampaignAclDestroyPathParams['user'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignAclDestroyResponse>> {
	return axiosInstance.delete(`/campaigns/${campaign}/access/${user}`, config)
}
